import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ErrorService} from '@services/error/error.service';
import {Observable, throwError} from 'rxjs';
import {IAdvertiserCompany} from '@interfaces/advertiser/user';
import {catchError, share} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdvertiserUserService {
  constructor(private http: HttpClient,
              private errorService: ErrorService) {
  }


  public getCompanyData(): Observable<IAdvertiserCompany> {
    return this.http.get<IAdvertiserCompany>('advertizer/company')
      .pipe(
        catchError((err) => {
          this.errorService.showError(err);
          return throwError(err);
        })
      );
  }

  public updateCompanyData({companyName, address}: { companyName: string, address: string }): Observable<IAdvertiserCompany> {
    return this.http.patch<IAdvertiserCompany>('advertizer/company', {companyName, address})
      .pipe(
        share(),
        catchError((err) => {
          this.errorService.showError(err);
          return throwError(err);
        })
      );
  }
}
